module.exports = __webpack_public_path__ + "static/media/groupOfCompanies.141544a3.png";